var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.895 46.8226C28.13 47.0926 26.87 47.0926 26.105 46.8226C19.58 44.5951 5 35.3026 5 19.5526C5 12.6001 10.6025 6.9751 17.51 6.9751C21.605 6.9751 25.2275 8.9551 27.5 12.0151C29.7725 8.9551 33.4175 6.9751 37.49 6.9751C44.3975 6.9751 50 12.6001 50 19.5526C50 35.3026 35.42 44.5951 28.895 46.8226Z",
    fill: "#DD2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.e19296b5a33b20d98cc025e9e439e615.svg";
export { ForwardRef as ReactComponent };